module.exports = __webpack_public_path__ + "static/media/giagia.68868b78.jpg";